import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import ProductType from 'bundles/payments-common/common/ProductType';
import type { CartCreateOptions } from 'bundles/payments-common/common/types';
import createCartPromise from 'bundles/payments-common/utils/cartCreation/createCart';

/**
 * Create a Self-Paced Project Cart. NOTE: Refer to ./createCart for more information.
 * @param {string} id - The courseId
 * @param {Object} options - Refer to ./createCart
 * @returns {Promise.<Object>} ./createCart response.
 */
export default function (courseId: string, options: Partial<CartCreateOptions>): Promise<CartsV2> {
  const data = {
    productItems: [
      {
        productType: ProductType.VERIFIED_CERTIFICATE,
        productItemId: courseId,
        productAction: 'Buy',
        cartItemIdToRefund: {},
        metadata: {
          'org.coursera.payment.ProjectCartItemMetadata': {},
        }, // TODO: Usages of ProjectCartItemMetadata can be cleaned up after https://coursera.atlassian.net/browse/SUBSCRIP-2349 has been completed.
      },
    ],
    ...options,
  };

  return createCartPromise(data);
}
